module.exports = __webpack_public_path__ + "img/小熊猫生物.4bc95f5c.png";